<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M12 3H5a2 2 0 00-2 2v7a2 2 0 002 2h7a2 2 0 002-2V5a2 2 0 00-2-2zm0 9H5V5h7zM18.28 7H28a1 1 0 000-2h-9.72a1 1 0 000 2zM28 10h-9.72a1 1 0 000 2H28a1 1 0 000-2zM12 18H5a2 2 0 00-2 2v7a2 2 0 002 2h7a2 2 0 002-2v-7a2 2 0 00-2-2zm0 9H5v-7h7zM28 20h-9.72a1 1 0 000 2H28a1 1 0 000-2zM28 25h-9.72a1 1 0 000 2H28a1 1 0 000-2z"/></svg>